// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { updatePassiveRepeaterStore } from 'redux/modules/pathDetails'
import getPassiveRepeaterDataFromPathDetailsForm from './getPassiveRepeaterDataFromPathDetailsForm'

// take what's in the redux-form state and store that
// in this pathDetails state.
const updatePassiveStoreFromForm = () => (dispatch, getState) => {
  const prs = dispatch(getPassiveRepeaterDataFromPathDetailsForm())
  dispatch(updatePassiveRepeaterStore(prs))
}

export default updatePassiveStoreFromForm
